import ctgNameData from '../data/ctgNameData'
import { StickerCategory } from '../types'

export const getEmojinameByEmojiIndex = (
  emojiIndex: number,
  everyEmojiCategory: StickerCategory[],
) => {
  const emojiCategory = everyEmojiCategory.find((emojiCategory) => {
    return emojiCategory.index === emojiIndex
  })
  if (!emojiCategory) {
    return undefined
  }
  const emojiAndName = ctgNameData.find(
    ({ emoji }) => emoji === emojiCategory.icon,
  )
  return emojiAndName
}
export const getEmojinameByIcon = (icon: string) => {
  const data = ctgNameData.find((data) => data.emoji === icon)
  return data
}
